(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ancarta-localization"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ancartaLocaleInit) return;
    window.__ancartaLocaleInit = true;

    // Changing a selector submits only its own form (country OR language).
    document.addEventListener('change', function (event) {
      var select = event.target.closest && event.target.closest('[data-ancarta-locale-select]');
      if (!select || !select.form) return;
      if (typeof select.form.requestSubmit === 'function') {
        select.form.requestSubmit();
      } else {
        select.form.submit();
      }
    });

    // Header popover: close on outside click and on Escape (focus returns to the toggle).
    document.addEventListener('click', function (event) {
      document.querySelectorAll('[data-ancarta-locale-popover][open]').forEach(function (popover) {
        if (!popover.contains(event.target)) popover.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-ancarta-locale-popover][open]').forEach(function (popover) {
        popover.removeAttribute('open');
        var summary = popover.querySelector('summary');
        if (summary) summary.focus();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
